import {
  HEADLESS_CATEGORY_PAGE,
  HEADLESS_SEARCH_PAGE_MATCHER
} from 'constants/links';

export const CURRENT_PAGE = [
  { path: HEADLESS_CATEGORY_PAGE, pageName: 'categoryPage' },
  { path: HEADLESS_SEARCH_PAGE_MATCHER, pageName: 'searchPage' }
];
export const STORE_LOCATOR_TOOL_TIP = 'STORE_LOCATOR_TOOL_TIP';
